import './Mapa2.css'

import { Col, Container, Row, Table } from 'react-bootstrap'
import 'leaflet/dist/leaflet.css'
import { Bar, Line } from 'react-chartjs-2';
import 'chartjs-adapter-moment';
import { forwardRef, useEffect,  useImperativeHandle,  useRef, useState } from 'react'
import Moment from 'react-moment'
import L from 'leaflet';
import 'react-data-grid/lib/styles.css';
import { useNavigate } from 'react-router-dom'

const position = [-12.32362979101804, -42.28573502390884];

const labels = [];
var circleMarkers = [];

var exibiuShape = false;

var legenda = [];
var legenda2 = [];

var geojsonFeature = require('../Mapa/BA/BA_Municipios_2021.json');

var dados_municipios_grlpois = require('../Mapa/BA/dados_grlpois.json');
var dados_municipios_por_data_grlpois = null;
var dados = [];
var dados2 = [];

var dados_totais = [];
var dados_totais_grlpois = [];

var teste_data = "";

function checkDado(dado){
  return dado['date'] === teste_data;
}

var datas2 = [];

dados_municipios_grlpois["amostras"].forEach(function(amostra) {
  var obj = {
    "date" : amostra["data"],
    "observed_number" : amostra["observed_number"],
    "exceeds_threshold" : amostra["exceeds_threshold"],
    "upper_bound_threshold" : amostra["upper_bound_threshold"],
    "excess_higher_estimate" : amostra["excess_higher_estimate"],
    "percent_excess_higher_estimate" : amostra["percent_excess_higher_estimate"]
  };
  
  /*obj[date] = municipio["atendimento"]["data"];
  obj['total_geral'] = municipio["atendimento"]["total_geral"];
  obj['total_gripal'] = municipio["atendimento"]["total_gripal"];*/

  datas2.push(obj["date"]);

  var busca = dados_totais_grlpois.find(dt => dt["date"] === obj["date"]);

  if(busca != null){
    teste_data = obj["date"];
    obj["observed_number"] = obj["observed_number"] + busca["observed_number"];
    obj["exceeds_threshold"] = obj["exceeds_threshold"] + busca["exceeds_threshold"];
    obj["upper_bound_threshold"] = obj["upper_bound_threshold"] + busca["upper_bound_threshold"];
    obj["excess_higher_estimate"] = obj["excess_higher_estimate"] + busca["excess_higher_estimate"];
    obj["percent_excess_higher_estimate"] = obj["percent_excess_higher_estimate"] + busca["percent_excess_higher_estimate"];
    var idx = dados_totais_grlpois.findIndex(checkDado);
    dados_totais_grlpois[idx] = obj;
  } else {
    dados_totais_grlpois.push(obj);
  }
});

var datas = [];
var alterandoData = false;
var filtrandoMunicipio = false;

function preparaNome(texto){
  var temp = texto.replace("\u00c3", "Ã");
  return temp;
}


var layerTile = null;
var layerGroup = null;
var posicao = localStorage.getItem('posicaoScroll');

var legend = null;

var circleOld = null;
var layerOld = null;

var shapeFileMapa = null;

var texto_grafico_dark = "#fff";
var texto_grafico_light = "#000";
const Mapa2 = forwardRef((props, ref) => { 
  var dados_observed_number = [];
  var dados_upper_bound_threshold = [];
  var dados_excess_higher_estimate = [];
  var nomes_municipios = [{
    "cod_ibge":0,
    "municipio": props.data === 'pt' ? "Todos" : "All"
  }];

 geojsonFeature["features"].forEach(function(municipio) {
    nomes_municipios.push({
      "cod_ibge" : municipio["properties"]["CD_MUN"],
      "municipio":municipio["properties"]["NM_MUN"]
    });
  });

  var nomes_variaveis = [
    {
      "id":0,
      "nome": props.data === 'pt' ? "Todos" : "All"
    }
  ]


  //dados novo grafico
  dados_totais_grlpois.forEach(function (dado){
    var obj = {};
    obj['data'] = dado["date"];
    obj['total'] = dado["observed_number"];
    dados_observed_number.push(obj);
  
    var obj2 = {};
    obj2['data'] = dado["date"];
    obj2['total'] = dado["upper_bound_threshold"];
    dados_upper_bound_threshold.push(obj2);
  
    var obj3 = {};
    obj3['data'] = dado["date"];
    obj3['total'] = dado["excess_higher_estimate"];
    dados_excess_higher_estimate.push(obj3);
  });
  
  
  dados_observed_number = Object.fromEntries(
    dados_observed_number.map(({data, total}) => [data, total])
  );
  dados_upper_bound_threshold = Object.fromEntries(
    dados_upper_bound_threshold.map(({data, total}) => [data, total])
  );
  dados_excess_higher_estimate = Object.fromEntries(
    dados_excess_higher_estimate.map(({data, total}) => [data, total])
  );

  const options = {
    responsive: true,
    layout:{
      padding: {
        left: 5,
        right: 10,
        top: -25,
        bottom: 5
      }
    },
    plugins: {
      legend: {
        onClick: null,
        position: 'top',
        labels: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: { 
            size: 18
          }
        }
      },
      title: {
        fullSize: true,
        display: true,
        text: '',
      },
    },
    scales: {
      y: {  // not 'yAxes: [{' anymore (not an array anymore)
        ticks: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
          // fontSize: 18,
          font: {
            size: 14, // 'size' now within object 'font {}'
          },
          stepSize: 1000,
          beginAtZero: true
        }
      },
      x: {  
        ticks:{
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light
        },
        type: 'time',
        time: {
          parser: 'YYYY/MM/DD',
          unit: 'day',
          unitStepSize: 7,
          displayFormats: {
            'day': 'DD/MM/YYYY'
          }
        }
      }
    }
  };
  
  const options2 = {
    responsive: true,
    layout:{
      padding: {
        left: 5,
        right: 10,
        top: -25,
        bottom: 5
      }
    },
    plugins: {
      legend: {
        onClick: null,
        position: 'top',
        labels: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: { 
            size: 18
          }
        }
      },
      title: {
        display: true,
        text: '',
      },
    },
    scales: {
      y: {  // not 'yAxes: [{' anymore (not an array anymore)
        
        ticks: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
          font: {
            size: 14, // 'size' now within object 'font {}'
          },
          stepSize: 1000,
          beginAtZero: true
        }
      },
      x: {
        ticks:{
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light
        },
        type: 'time',
        time: {
          parser: 'YYYY/MM/DD',
          tooltipFormat: 'll HH:mm',
          unit: 'day',
          unitStepSize: 7,
          displayFormats: {
            'day': 'DD/MM/YYYY'
          }
        }
      }
    }
  };

  var listBindPopup = [];

  const navigate = useNavigate();

  window.onscroll = function (e) {
    posicao = window.scrollY;
    localStorage.setItem('posicaoScroll', JSON.stringify(posicao));
  }

  function logout(){
    props.loginToParent(false, "");
  }

  function tabelaOrdenada() {
    var tMakers = [...markers];
    
    if(campoOrdem === "taxa"){
      if(decrescente) {
        tMakers.sort((a,b) => (parseFloat(a[campoOrdem]) > parseFloat(b[campoOrdem])) ? -1 : 1);
      } else {
        tMakers.sort((a,b) => (parseFloat(a[campoOrdem]) < parseFloat(b[campoOrdem])) ? -1 : 1);
      }
    } 
    else
    if(campoOrdem === "municipio"){
      if(decrescente) {
        tMakers.sort((a,b) => b[campoOrdem].localeCompare(a[campoOrdem]));
      } else {
        tMakers.sort((a,b) => a[campoOrdem].localeCompare(b[campoOrdem]));
      }
    } else {
      if(decrescente) {
        tMakers.sort((a,b) => (a[campoOrdem] > b[campoOrdem]) ? -1 : 1);
      } else {
        tMakers.sort((a,b) => (a[campoOrdem] > b[campoOrdem]) ? 1 : -1);
      }
    }

    if(posicao) {
        setTimeout(function() {
            window.scrollTo(0, posicao);
        }, 1);
    }

    return tMakers;
  }

  let map = useRef(null);

  function criarLegenda() {
    if(legend != null){
      map.current.removeControl(legend);
      legend = null;
    }
    legend = L.control({ position: "bottomleft" });

    legend.onAdd = function(map) {
      var div = L.DomUtil.create("div", "legend");
      div.innerHTML += '<div class="lgd">';
      div.innerHTML += '<table><tr><th  bgcolor="#009827">&nbsp</th><th  bgcolor="#FAFF00">&nbsp</th><th bgcolor="#FF1200">&nbsp</th></tr><tr><td style="text-align:left">75%</td><td style="text-align:center"></td><td style="text-align:right">100%</td></tr>';
      div.innerHTML += '</table>';
      div.innerHTML += '</div>';
      
      return div;
    };
    
    legend.addTo(map.current);
  }

  function getName(cod_ibge){
    var nome = "";
    Object.keys(shapeFileMapa["_layers"]).forEach((shape) => {
      if(cod_ibge == shapeFileMapa["_layers"][shape]["feature"]["properties"]["CD_MUN"].substring(0, 6)){
        nome = shapeFileMapa["_layers"][shape]["feature"]["properties"]["NM_MUN"]  
      }      
    });

    return nome;
  }

  function getRadius(){
    var radius = 0.5;
    switch(map.current.getZoom()){
      case 3:  radius = 0.5; break;
      case 4:  radius = 1; break;
      case 5:  radius = 2; break;
      case 6:  radius = 3;   break;
      case 7:  radius = 5;   break;
      case 8:  radius = 7;   break;
      case 9:  radius = 16;  break;
      case 10: radius = 20;  break;
      case 11: radius = 25;  break;
      case 12: radius = 30;  break;
      case 13: radius = 40;  break;
      case 14: radius = 50;  break;
      case 15: radius = 45;  break;
      case 16: radius = 50;  break;
      case 17: radius = 55;  break;
      case 18: radius = 60;  break;
    }
    return radius;
  }

  function highlightFeature(e) {
    //var cd_mun = e["target"]["feature"]["properties"]["CD_MUN"];
    //console.log(e);
  }

  function onEachFeature(feature, layer) {
    layer.on({
        click: () => {
          var encontrou = false;
          dados_municipios_por_data_grlpois["municipios"].forEach(function(municipio) {
            if(String(municipio["cod_ibge"]) === (layer["feature"]["properties"]["CD_MUN"]).substring(0,6)){  
              encontrou = true;
            }
          });

          if(!encontrou)
            return;

          if(layerOld != null){
            layerOld.setStyle({weight: 0.5,color:layerOld["fillColor"]});
            layerOld = null;   
          } 
            layer.setStyle({weight: 3.5, color: 'white'}); 
            layerOld = layer; 

            var ling = 'en';
                              
            const elemento = document.getElementsByClassName("selected-lang");
            elemento[0].classList.forEach((item) => {
              if(item === "pt")
                ling = "pt";
            });

            filtrarMunicipio(parseInt(layer["feature"]["properties"]["CD_MUN"]), false, ling);
        },
        mouseover: highlightFeature,
    });
  }

  useEffect(() => {
    if(!props.login){
      navigate("/login");
      return;
    }
    
    //let url = ;
    if(layerTile != null){
      map.current.removeLayer(layerTile);
    }

    var url = props.theme === "dark" ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";

    if(map.current == null){
      map.current = L.map("map");
    } else {
      map.current.invalidateSize();
    }

    const defaultCenter = position;
    const defaultZoom = 6.2;

    layerTile = L.tileLayer(url, {
      defaultZoom: defaultZoom,
      maxZoom: 18,
      id: 'mapbox.streets'
    });

    map.current.setView(defaultCenter, defaultZoom);
    layerTile.addTo(map.current);
    getData2 (dataSelecionada2);

    if(shapeFileMapa == null){
      shapeFileMapa = L.geoJSON(geojsonFeature, {
          style: function(feature) {
              /*switch (feature.properties.CD_MUN) {
                  case '2900108': return {color: "#fff"};
                  case '2900207': return {color: "#0000ff"};
              }*/
              return {weight:0.5, fillColor: "#D8D8D8"};
          },
          onEachFeature: onEachFeature,
      }).addTo(map.current);
    }

  }, [map])

  var borderColor = "rgb(36, 245,11)";
  var backgroundColor = "rgba(36, 245,11, 0.5)";

  var borderColor2 = "rgb(245 , 75 , 9)";
  var backgroundColor2 = "rgba(245 , 75 , 9, 0.5)";

  //var borderColor3 = "rgb(36, 245,11)";
  //var backgroundColor3 = "rgba(36, 245,11, 0.5)";

  var borderColor3 = "rgb(255, 41, 73)";
  var backgroundColor3 = "rgba(255, 41, 73, 0.5)";
  

  const [data_observed_number, setData_observed_number] = useState({
    legenda,
    datasets: [
      {
        fill: true,
        label: props.data === 'pt' ? 'Número observado' : 'Observed Number',
        data: dados_observed_number,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
      },
      {
        fill: true,
        label: props.data === 'pt' ? 'Limite Superior' : 'Upper Bound Threshold',
        data: dados_upper_bound_threshold,
        borderColor: borderColor2,
        backgroundColor: backgroundColor2,
      },
    ],
    
  });

  const [data_excess, setData_excess] = useState({
    legenda,
    datasets: [
      {
        fill: true,
        label: props.data === 'pt' ? 'Excesso Superior' : 'Excess Higher',
        data: dados_excess_higher_estimate,
        borderColor: borderColor3,
        backgroundColor: backgroundColor3,
      }
    ],
    
  });


  const [data, setData] = useState({
    legenda,
    datasets: [
      {
        label: props.data === 'pt' ? 'Total de Atendimentos' : 'Total Encounters',
        data: dados,
        backgroundColor: 'rgba(255, 99, 132, 1.0)',
      }
    ],
  })
  const [data2, setData2] = useState({
    legenda2,
    datasets: [
      {
        label: props.data === 'pt' ? 'Atendimentos Gripais' : 'Flu Encounters',
        data: dados2,
        backgroundColor: 'rgba(53, 162, 235, 1)',
      }
    ],
  })

  const options_linha = {
    responsive: true,
    layout:{
      padding: {
        left: 5,
        right: 10,
        top: -25,
        bottom: 5
      }
    },
    plugins: {
      legend: {
        onClick: null,
        position: 'top',
        labels: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light,
          font: { 
            size: 18
          }
        }
      },
      title: {
        display: true,
        text: '',
      },
    },
    scales: {
      y: {  // not 'yAxes: [{' anymore (not an array anymore)
        ticks: {
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
          // fontSize: 18,
          font: {
            size: 14, // 'size' now within object 'font {}'
          },
          stepSize: 1,
          beginAtZero: true,
          suggestedMin: 0,
        },
        min: 0,
      },
      x: {  // not 'xAxes: [{' anymore (not an array anymore)
        
        ticks:{
          color: props.theme === "dark" ? texto_grafico_dark : texto_grafico_light
        },
        type: 'time',
        time: {
          parser: 'YYYY/MM/DD',
          unit: 'day',
          unitStepSize: 7,
          displayFormats: {
            'day': 'DD/MM/YYYY'
          }
        }
      }
    }
  };

  const [markers, setMakers] = useState([])
  const [municipioSelecionado, setMunicipioSelecionado] = useState(props.data === 'pt' ? "Todos" : "All")
  const [variavelSelecionada, setVariavelSelecionada] = useState(props.data === 'pt' ? "Todas" : "All")
  const [campoOrdem, setCampoOrdem] = useState("total_geral");
  const [decrescente, setDecrescente] = useState(false);
  const [dataSelecionada2, setDataSelecionada2] = useState(datas2[0])
  const [idxDataSelecionada, setIdxDataSelecionada] = useState(0)
  const [maiorTaxa, setMaiorTaxa] = useState(0)
  const [menorTaxa, setMenorTaxa] = useState(0)
  const [tableData, setTableData] = useState([])

  async function filtrarMunicipio(cod_ibge, pintaCirculo, linguagem){
    if(filtrandoMunicipio)
      return;
    
    filtrandoMunicipio = true;

    var municipio_sel = '';
    dados = [];
    dados2 = [];
    dados_observed_number = [];
    dados_upper_bound_threshold = [];
    dados_excess_higher_estimate = [];
    if(cod_ibge === "Todos" || cod_ibge === "All") 
    {
      setMunicipioSelecionado(cod_ibge);
      dados_totais_grlpois.forEach(function (dado){
        var obj = {};
        var obj2 = {};
        var obj3 = {};

        console.log(dado);

        obj['data'] = dado["date"];
        obj['total'] = dado["observed_number"];
        dados_observed_number.push(obj);
  
        obj2['data'] = dado["date"];
        obj2['total'] = dado["upper_bound_threshold"];
        dados_upper_bound_threshold.push(obj2);

        obj3['data'] = dado["date"];
        obj3['total'] = dado["excess_higher_estimate"];
        dados_excess_higher_estimate.push(obj3);
      });
    }
    else
    {      
      var isNumber = !isNaN(cod_ibge);

      var cod_ibge_selecionado = String(cod_ibge).substring(0,6);

      var nomeCidade = "";
      geojsonFeature["features"].forEach(function(municipio) {
        if(isNumber ? (String(municipio["properties"]["CD_MUN"]).substring(0,6) === cod_ibge_selecionado) : municipio["properties"]["NM_MUN"] === cod_ibge)
        {
          nomeCidade = municipio["properties"]["NM_MUN"];
          cod_ibge_selecionado = String(municipio["properties"]["CD_MUN"]).substring(0,6);
        }
      });

      var encontrou = false;

      dados_municipios_grlpois["municipios"].forEach(function(municipio) {
        if(String(municipio["cod_ibge"]) === cod_ibge_selecionado){  
          console.log(nomeCidade);
          setMunicipioSelecionado(nomeCidade);
          municipio_sel = nomeCidade;
          municipio["amostras"].forEach(function(amostra){
          var obj = {};
          obj['data'] = amostra["data"];
          obj['total'] = amostra["observed_number"];
          dados_observed_number.push(obj);
    
          var obj2 = {};
          obj2['data'] = amostra["data"];
          obj2['total'] = amostra["upper_bound_threshold"];
          dados_upper_bound_threshold.push(obj2);
          
          var obj3 = {};
          obj3['data'] = amostra["data"];
          obj3['total'] = amostra["excess_higher_estimate"];
          dados_excess_higher_estimate.push(obj3);

          encontrou = true;
          });              
        }
      });    
      
      if(!encontrou){
        filtrandoMunicipio = false;
        return;
      }
      else 
      {
        if(circleOld != null && pintaCirculo){
          circleOld.setStyle({weight: 0.5, color:circleOld["fillColor"]});
          circleOld = null; 
        }
      }
    }
    dados_observed_number = Object.fromEntries(
      dados_observed_number.map(({data, total}) => [data, total])
    );
    dados_upper_bound_threshold = Object.fromEntries(
      dados_upper_bound_threshold.map(({data, total}) => [data, total])
    );
    dados_excess_higher_estimate = Object.fromEntries(
      dados_excess_higher_estimate.map(({data, total}) => [data, total])
    );

    setData_observed_number({
      legenda2,
      datasets: [
        {
          fill: true,
          label: linguagem === 'pt' ? 'Número observado' : 'Observed Number',
          data: dados_observed_number,
          borderColor: borderColor,
          backgroundColor: backgroundColor,
        },
        {
          fill: true,
          label: linguagem === 'pt' ? 'Limite Superior' : 'Upper Bound Threshold',
          data: dados_upper_bound_threshold,
          borderColor: borderColor2,
          backgroundColor: backgroundColor2,
        },
      ],
      }
    );

    setData_excess({
      legenda,
      datasets: [
        {
          fill: true,
          label: linguagem === 'pt' ? 'Excesso Superior' : 'Excess Higher',
          data: dados_excess_higher_estimate,
          borderColor: borderColor3,
          backgroundColor: backgroundColor3,
        }
      ],
      
    });

    getMakers(municipio_sel, true, props.data);    

    filtrandoMunicipio = false;
  }

  useImperativeHandle(ref, (linguagem) => ({

    refreshMap(linguagem){
      if((map.current == null))
        return;
      if(layerTile != null){
        map.current.removeLayer(layerTile);
      }

      var url = linguagem === "dark" ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";

      const defaultCenter = position;
      const defaultZoom = 6.2;

      layerTile = L.tileLayer(url, {
        defaultZoom: defaultZoom,
        maxZoom: 18,
        id: 'mapbox.streets'
      });

      map.current.setView(defaultCenter, defaultZoom);
      layerTile.addTo(map.current);
    },
 
    refreshGraph(linguagem){
      if(layerGroup != null)
        map.current.removeLayer(layerGroup);
      
      circleMarkers = [];
      
      getMakers("", true, linguagem);   
      getData2 (dataSelecionada2);  
      //const labels_linha = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  
      setData_observed_number({
        legenda2,
        datasets: [
          {
            fill: true,
            label: linguagem === 'pt' ? 'Número observado' : 'Observed Number',
            data: dados_observed_number,
            borderColor: borderColor,
            backgroundColor: backgroundColor,
          },
          {
            fill: true,
            label: linguagem === 'pt' ? 'Limite Superior' : 'Upper Bound Threshold',
            data: dados_upper_bound_threshold,
            borderColor: borderColor2,
            backgroundColor: backgroundColor2,
          },
        ],
        }
      );
  
      setData_excess({
        legenda,
        datasets: [
          {
            fill: true,
            label: linguagem === 'pt' ? 'Excesso Superior' : 'Excess Higher',
            data: dados_excess_higher_estimate,
            borderColor: borderColor3,
            backgroundColor: backgroundColor3,
          }
        ],
        
      });
    }
  }));

  function preparaMesAno(data){
    return data.substring(5,7) +"/"+ data.substring(0,4);
  }
  
  function geraEspacoHTML(quantidade){
    var saida = "";
    for(let i = 0 ; i <  quantidade; i ++){
      saida += "&nbsp;";
    }
    return saida;
  }

  function getMakers (nomeMunicipio, somenteMapa, linguagem) {
    
    if(circleMarkers.length <= 0){
      var tempCircleMarkers = [];
      var tempMakers = [];
      for(let i = 0; i < dados_municipios_por_data_grlpois["municipios"].length; i++){
        tempMakers.push({
          "cod_ibge": dados_municipios_por_data_grlpois["municipios"][i]["cod_ibge"],
          "color_indicator": dados_municipios_por_data_grlpois["municipios"][i]["color_indicator"],
          "cor": dados_municipios_por_data_grlpois["municipios"][i]["color_indicator"] === 3 ? '#980000' : dados_municipios_por_data_grlpois["municipios"][i]["color_indicator"] === 1 ? '#009827' : '#FAFF00',
          "exceeds_threshold": dados_municipios_por_data_grlpois["municipios"][i]["exceeds_threshold"],
          "excess_higher_estimate": dados_municipios_por_data_grlpois["municipios"][i]["excess_higher_estimate"],
          "observed_number": dados_municipios_por_data_grlpois["municipios"][i]["observed_number"],
          "percent_excess_higher_estimate": dados_municipios_por_data_grlpois["municipios"][i]["percent_excess_higher_estimate"],
          "upper_bound_threshold": dados_municipios_por_data_grlpois["municipios"][i]["upper_bound_threshold"],
          "name" : getName(dados_municipios_por_data_grlpois["municipios"][i]["cod_ibge"])
        });
      }   
      
      for(let i = 0; i < tempMakers.length; i++){
        listBindPopup.push({
          "cod_mun" : tempMakers[i]["cod_ibge"],
          "conteudo" : linguagem === 'pt' ?
          `<h5>Excesso Superior</h5>  Excesso Superior ${tempMakers[i]["excess_higher_estimate"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Municipio ${tempMakers[i]["name"]} ${geraEspacoHTML(50-tempMakers[i]["name"].length)}
                                    Número observado ${tempMakers[i]["observed_number"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Limite Superior ${tempMakers[i]["upper_bound_threshold"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Semana epidemiológica  ${preparaMesAno(dataSelecionada2)}
                                    ` : `<h5>Excess Higher</h5> Excess Higher ${tempMakers[i]["excess_higher_estimate"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    County ${tempMakers[i]["name"]} ${geraEspacoHTML(51-tempMakers[i]["name"].length)} 
                                    Observed Number ${tempMakers[i]["observed_number"]}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Upper Bound Threshold ${tempMakers[i]["upper_bound_threshold"]} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Epidemiological Week ${preparaMesAno(dataSelecionada2)} 
                                    `
        });
      }
        Object.keys(shapeFileMapa["_layers"]).forEach((shape) => {
          
          for(let i = 0; i < tempMakers.length; i++){
            if(tempMakers[i]["cod_ibge"] == shapeFileMapa["_layers"][shape]["feature"]["properties"]["CD_MUN"].substring(0, 6)){
              //shapeFileMapa["_layers"][shape]["options"]["color"] = tempMakers[i]["cor"];
              var cor = tempMakers[i]["cor"];
              var weight_ = 0.5;
              if(nomeMunicipio === shapeFileMapa["_layers"][shape]["feature"]["properties"]["NM_MUN"]){
                cor = "#fff";
                weight_ = 3.5;
              }
              shapeFileMapa["_layers"][shape].setStyle({weight:weight_, color:cor, fillColor:tempMakers[i]["cor"]});
              break;
            }
          }

          for(let i = 0 ; i < listBindPopup.length; i++){
            if(parseInt(shapeFileMapa["_layers"][shape]["feature"]["properties"]["CD_MUN"].substring(0, 6)) == parseInt(listBindPopup[i]["cod_mun"])){
              shapeFileMapa["_layers"][shape].bindPopup(listBindPopup[i]["conteudo"]);
              break;
            }
          }
        });
        criarLegenda();
      }
      circleMarkers = tempCircleMarkers;
  
  return [...markers];
}

  const getData2=(dt)=>{
    if(dt != undefined){
      fetch('BA/municipios_por_datas/grlpois/dados_'+dt.replace(" 00:00:00", "")+'_grlpois.json'
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
        )
          .then(function(response){
            //Limpa pontos anteriores
            return response.json();
          })
          .then(function(myJson) {
            dados_municipios_por_data_grlpois = myJson;
            getMakers(municipioSelecionado, false, props.data);
          });
    }
  }

/*
  const getData=(dt)=>{
    if(dt != undefined){
      fetch('BA/municipios_por_datas/dados_'+dt.replace(" 00:00:00", "")+'.json'
      ,{
        headers : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
      )
        .then(function(response){
          //Limpa pontos anteriores
          return response.json();
        })
        .then(function(myJson) {
          dados_municipios_por_data = myJson;
          getMakers(municipioSelecionado, false, props.data);
        });
    }
  }*/

  function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
  }

  async function mudaData(idx){
    if(alterandoData)
      return;
    
    alterandoData = true;  

    circleMarkers = [];
    setDataSelecionada2(datas2[idx])
    getData2(datas2[idx]);
    await timeout(1000);
    alterandoData = false;
  }

  const arbitraryLine = {
    id: 'arbitraryLine',
    beforeDatasetsDraw(chart, args, pluginOptions){
      const {ctx, chartArea: { top, bottom, left, right, width, heigth}, scales:{x, y}} = chart;
      ctx.save();

      ctx.beginPath();
      ctx.lineWidth = 3;
      ctx.strokeStyle = 'white';
      ctx.moveTo(x.getPixelForValue(2), top);
      ctx.lineTo(x.getPixelForValue(2), bottom);
      ctx.stroke();
      ctx.restore();
    }
  }



    if(props.login){
      return (
          <Container>
            <br></br>
            <br></br>
            <Row>
              <Col >
                <Moment date={dataSelecionada2} format='DD/MM/YYYY'></Moment>
                <br></br>
              
                <form onChange={(event) => mudaData(event.target.value)}>
                  <input type={"range"} max={datas2.length} min={0} defaultValue={0}  ></input>
                </form>
                <div className='mapa'>
                  <h5>{props.data === 'pt' ? 'Excesso Superior' : 'Excess Higher'}</h5>
                  <div id="map" className="normalscreen"></div>
                </div>
              </Col>
              <Col>
              
              <select name="municipios" id="municipio" value={municipioSelecionado} onChange={event => filtrarMunicipio(event.target.value, true, props.data)}>
                  {nomes_municipios.map((e, key) => {
                                        return (
                                          <option key={key} value={e["cod_municipio"]}>{e["municipio"]}</option>       
                                        );
                        })}
              </select> 
              <br></br>
              <select name="variaveis" id="variavel" value={variavelSelecionada} onChange={event => console.log(event.target.value)}>
                  {nomes_variaveis.map((e, key) => {
                                        return (
                                          <option key={key} value={e["id"]}>{e["nome"]}</option>
                                        );
                  })                 
                  }
              </select> 
                
              <div>
                <h5>{props.data === 'pt' ? 'Total' : 'Total'}</h5>
                <Row>
                  <Col> 
                    <div className='grafico'>
                      <Line className='linha_grafico2' options={options_linha} data={data_excess} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col> 
                    <div className='grafico'>
                    <Line 
                        className='linha_grafico' 
                        options={options_linha} 
                        data={data_observed_number} 
                        plugins= {[arbitraryLine]}  
                      />
                    </div>      
                  </Col>
                </Row>
              </div>
              </Col>
            </Row>
            <div className='table_container'>
              <div className='table'>
                <Table id="dtBasicExample" striped bordered hover variant={props.theme === "dark" ? "dark" : ""}>
                  <thead>
                    <tr>
                      <th><a href='#' style={{color: campoOrdem === "municipio" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "municipio"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                        setCampoOrdem("municipio")}}> 
                        <img src="/imagens/icones/setas-ordenadas.png" ></img> Municipio</a></th>
                      <th><a href='#' style={{color: campoOrdem === "total_gripal" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "total_gripal"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                        setCampoOrdem("total_gripal")}}> <img src='/imagens/icones/setas-ordenadas.png'></img> Atendimentos gripais </a></th>
                      <th><a href='#' style={{color: campoOrdem === "total_geral" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "total_geral"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                        setCampoOrdem("total_geral")}}> <img src='/imagens/icones/setas-ordenadas.png'></img> Atendimentos totais </a></th>
                      <th><a href='#' style={{color: campoOrdem === "taxa" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "taxa"){ setDecrescente(!decrescente);} else {setDecrescente(false);}  
                        setCampoOrdem("taxa")}}> <img src='/imagens/icones/setas-ordenadas.png'></img> Taxa Gripal(%)</a></th>
                      <th><a href='#' style={{color: campoOrdem === "escolarizacao" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "escolarizacao"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                        setCampoOrdem("escolarizacao")}}> <img src='/imagens/icones/setas-ordenadas.png'></img> Escolarização</a></th>
                      <th><a href='#' style={{color: campoOrdem === "ibp" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "ibp"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                        setCampoOrdem("ibp")}}><img src='/imagens/icones/setas-ordenadas.png'></img> IBP*</a></th>
                      <th><a href='#' style={{color: campoOrdem === "idhm" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "idhm"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                        setCampoOrdem("idhm")}}><img src='/imagens/icones/setas-ordenadas.png'></img> Idhm*</a></th>
                      <th><a href='#' style={{color: campoOrdem === "pib2020" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "pib2020"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                        setCampoOrdem("pib2020")}}><img src='/imagens/icones/setas-ordenadas.png'></img> PIB*</a></th>
                      <th><a href='#' style={{color: campoOrdem === "populacao" ? "cadetblue" : ""}} onClick={() => {
                        if(campoOrdem === "populacao"){ setDecrescente(!decrescente);} else {setDecrescente(false);} 
                        setCampoOrdem("populacao")}}><img src='/imagens/icones/setas-ordenadas.png'></img> População*</a></th>
                    </tr>
                  </thead>
                  <tbody>
                    {tabelaOrdenada().map((value, index) => {
                                        return (
                                          <tr key={index}>
                                            <td><a href='#' onClick={() => {filtrarMunicipio(value["cod_ibge"], true, props.data)}}>{value["municipio"]}</a></td>
                                            <td>{value["total_gripal"]}</td>
                                            <td>{value["total_geral"]}</td>
                                            <td>{value["taxa"]}</td>
                                            <td>{value["escolarizacao"]}</td>
                                            <td>{value["ibp"]}</td>
                                            <td>{value["idhm"]}</td>
                                            <td>{value["pib2020"]}</td>
                                            <td>{value["populacao"]}</td>
                                          </tr>
                                        );
                        })}  
                        
                  </tbody>
                </Table>
              </div>
            </div>
              
          </Container>  
        );
    } else {
      return(
        <div>Para visualizar os dados é necessário Login !</div>
      );
    }
});

export default Mapa2